import { ChangeDetectionStrategy,Component,Inject } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EInvoiceViewComponent } from '../e-invoice-view/e-invoice-view.component';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { EInvoiceDataService } from '../../services/e-invoice-data.service';
import { firstValueFrom, of } from 'rxjs';

export interface EInvoiceViewDialogComponentDialogData {
    versionId: number,
}
export type EInvoiceViewDialogComponentDialogReturnData = undefined;
@Component({
    selector: 'app-e-invoice-view-dialog',
    templateUrl: './e-invoice-view-dialog.component.html',
    styleUrls: ['./e-invoice-view-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EInvoiceViewDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        panelClass: [...appMatDialogDefaultConfig.panelClass, 'custom-dialog-class-fullscreen'],
    };
    eInvoiceEntity$: Promise<EInvoiceViewComponent['EInvoice']>;

    constructor(data: EInvoiceDataService, @Inject(MAT_DIALOG_DATA) dialogData: EInvoiceViewDialogComponentDialogData) {
        this.eInvoiceEntity$ = dialogData?.versionId ? data.getEInvoiceFromVersion(dialogData.versionId) : firstValueFrom(of(data.getMockEInvoice()));
    }
}
